<footer class="footer has-text-grey is-size-7">
	<div class="container">
		<div class="columns">
			<div class="column">
				<img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" *ngIf="brandService.logoSrc">
				<p *ngIf="brandService.domain != 'freerateupdate.com'">by freerateupdate.com</p>
			</div>

			<div class="column">
				<p class="is-size-4 is-size-5-mobile" *ngIf="officeStatus && officeStatus.answer">
					<a class="has-text-grey-dark" href="tel:{{ officeStatus.phone }}" target="_blank">
						Call {{ officeStatus.phonefancy }}
					</a>
				</p>

				<p>
					2 Ponds Edge Drive
					<br>
					Chadds Ford, PA 19317
				</p>

				<p>
					<span>
						NMLS #1154338. Go here for the FreeRateUpdate
						<a href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1154338" target="_blank">NMLS Consumer Access Page.</a>
					</span>
				</p>

				<p>
					For California Consumers, NMLS #1452444
				</p>
			</div>

			<div class="column">
				<p>
					<a href="/contact" target="_blank">Contact Us</a>
					|
					<a href="/privacy" rel="nofollow" target="_blank">Privacy Policy</a>
					|
					<a href="/cpra_policy" rel="nofollow" target="_blank">CPRA Policy</a>
					|
					<a href="/terms" rel="nofollow" target="_blank">General Terms</a>
					|
					<a href="/licensing_disclosure" rel="nofollow" target="_blank">Licensing Disclosure</a>
					|
					<a href="/approved-lenders" target="_blank">Approved Lenders</a>
				</p>
				<p>
					<a class="not-sell" href="/your_privacy_choices">Privacy Preferences</a>
				</p>
			</div>
		</div>

		<p class="has-text-centered">
			{{ brandService.domain }} is not a lender, loan modification company or foreclosure prevention/counseling company. {{ brandService.domain }} is not associated with or an affiliate of your current lender or servicer. This is not an offer by {{ brandService.domain }} to lend you money. Our goal is to provide an easy connection for homeowners looking for mortgage information to a licensed broker or lender who can assist you.
		</p>

		<p class="has-text-centered">
			Site is hosted by {{ brandService.domain }} for FreeRateUpdate.com.
		</p>

		<p class="has-text-centered">
			FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. &copy; FreeRateUpdate.com LLC 2008 - {{ currentYear }}. All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.
		</p>
	</div>
</footer>